import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../../auth.service";
import { EnvironmentHelper } from "../../services/env.helper";

@Component({
  selector: "versions",
  templateUrl: "./versions.component.html",
  styleUrls: ["./versions.component.css"],
})
export class VersionsComponent implements OnInit {
  apiVersion: any = null;
  uiVersion = "0.0.0";
  apkUrl = "";
  envName = "";

  isInApk = false;
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    private env: EnvironmentHelper,
    private auth: AuthService
  ) {
    this.apiUrl = `${env.apiBaseUrl}version/`;
    this.envName = env.environment;
  }

  ngOnInit(): void {
    this.checkIfInApk();
    this.loadUiVersion();

    const token = this.auth.token;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    this.envName = this.env.environment;
    this.http.get(this.apiUrl, { headers }).subscribe({
      next: (data) => (this.apiVersion = data),
    });
  }
  private loadUiVersion() {
    this.http.get("/assets/version.txt", { responseType: "text" }).subscribe({
      next: (version) => {
        this.uiVersion = version.trim();
        this.apkUrl = this.generateApkUrl();
      },
    });
  }

  private checkIfInApk() {
    this.isInApk = !!(window as any).cordova;
  }
  private generateApkUrl(): string {
    const version = this.uiVersion;

    switch (this.env.environment) {
      case "dev":
        return "https://op.docner.com/public/apk/app-debug.apk";
      case "acc":
        return `https://opdracht-acc.opstoom.nl/public/apk/opstoom-opdracht-acc-${version}.apk`;
      case "prod":
        return `https://opdracht.opstoom.nl/public/apk/opstoom-opdracht-${version}.apk`;
      default:
        return "";
    }
  }
}
